<template>
  <div class="login" :style="{width: '100%',height: '100%',backgroundImage: 'url(' + require('../assets/login_bg.jpg') + ')'}">
    <div class="my-login">
      <div v-if="plat == 1" class="my-login-title-class">迅集综合服务系统————支付管理登入</div>
      <div v-else-if="plat == 2" class="my-login-title-class">迅集综合服务管理系统————结算管理</div>
      <div class="my-login-class">
        <el-form label-width="80px" style="padding: 20px 20px 0 0;">
          <el-form-item label="账号" style="font-size: 16px;">
            <el-input v-model="account" placeholder="请输入账号" prefix-icon="el-icon-user-solid"></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input @keydown.native="enter($event)" v-model="password" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock"></el-input>
          </el-form-item>
        </el-form>
        <el-button class="login-button" type="primary" @click="login">登&nbsp;&nbsp;陆</el-button>
      </div>
    </div>
    <div v-if="plat == 1" class="footer-nav">迅果科技 Copyright @2020 gela technology Lto.</div>
    <div v-else-if="plat == 2" class="footer-nav">江西迅启启丰信息科技有限公司</div>
  </div>
</template>

<script>
import api from '@/api/api';
// import md5 from '@/utils/MD5';
import { passwdHmacSHA1 } from '@/utils';

export default {
  name: 'login',
  data() {
    return {
      account: '',
      password: '',
      uuid: '',
      plat: 1, // 1：迅果，2：启丰
    };
  },
  mounted() {
    this.plat = this.$store.state.plat;
  },
  methods: {
    login() {
      if (this.account === '') {
        this.$message({
          type: 'error',
          message: '账号不能为空',
        });
        return;
      }
      if (this.password === '') {
        this.$message({
          type: 'error',
          message: '密码不能为空',
        });
        return;
      }
      api.login({
        params: {
          data: {
            uaccount: this.account,
            upasswd: passwdHmacSHA1(this.password),
          },
        },
      }).then((res) => {
        console.log('res: ', res);
        if (!res || !res.data) {
          return;
        }
        if (res.data.checkRight === 1) {
          this.$store.commit('setIscheck', 1);
        } else {
          this.$store.commit('setIscheck', 0);
        }
        if (res.data.payRight === 1) {
          this.$store.commit('setIspay', 1);
        } else {
          this.$store.commit('setIspay', 0);
        }
        if (res.data.superManager === 1) {
          this.$store.commit('setSupermanager', 1);
        } else {
          this.$store.commit('setSupermanager', 0);
        }
        if (res.data.isManager === 1) {
          this.$store.commit('setIsmanager', 1);
        } else {
          this.$store.commit('setIsmanager', 0);
        }
        this.$store.commit('setAccountName', res.data.account);
        this.$router.push({ path: 'payexcels' });
      }).catch((err) => {
        console.log('err ============>', err);
        this.$message({
          type: 'error',
          message: err.tip || err.response,
        });
      });
    },
    enter(ev) {
      if (ev.keyCode === 13) {
        this.login();
      }
    },
  },
};
</script>

<style lang="less" scoped >
@import "../styles/reset.css";

@media screen and (max-height: 599px) {
  .title-nav {
    top: 80px;
  }
}
@media screen and (min-height: 600px) and (max-height: 700px) {
  .title-nav {
    top: 10%;
  }
}
@media screen and (min-height: 701px) and (max-height: 850px) {
  .title-nav {
    top: 15%;
  }
}
@media screen and (min-height: 851px) {
  .title-nav {
    top: 15%;
  }
}

.login {
  position: relative;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
}

.title-nav {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  height: 36px;
  line-height: 36px;
  color: black;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  width: 240px;
  img {
    height: 36px;
    width: 36px;
    float: left;
    border-radius: 6px;
  }
  span {
    color: black;
    text-align: center;
  }
}

.my-login{
  height: 350px;
  width: 450px;
  background: #eaedf0;
  position: absolute;
  top: 45%;
  left: 50%;
  z-index: 1001;
  border-radius: 8px;
  transform: translate(-50%, -60%);
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.23);
}

.my-login-title-class
{
   margin: 30px 0px 0px 0px;
   text-align: center;
   font-size: 18px;
   font-weight: bold;
}

.my-login-class {
  margin: 30px 30px;
}

.login-button {
  width: 300px;
  margin: 50px 0 0 60px;
  font-size: 18px;
}

.login-nav {
  height: 366px;
  width: 436px;
  background: #fff;
  position: absolute;
  top: 65%;
  left: 50%;
  z-index: 1001;
  border-radius: 8px;
  transform: translate(-50%, -60%);
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.23);
  .line-left, .line-right {
    border-top: 2px solid #20a0ff;
    width: 189px;
    position: absolute;
    top: 49px;
  }
  .account-icon {
    font-size: 18px;
    color: #99a9bf;
    height: 36px;
  }
  .login-account-nav {
    height: 366px;
    box-sizing: border-box;
    // .account-input {
    //   .el-input__inner {
    //     height: 50px !important;
    //     border-radius: 0;
    //   }
    //   &:last-child {
    //     margin-bottom: 0px!important;
    //   }
    //   margin-bottom: 20px;
    // }
    .account-btn {
      height: 40px;
      width: 340px;
      margin-top: 30px;
      border-radius: 4px;
      background: #20a0ff;
      font-size: 14px;
    }
    img {
      display: block;
      margin: 0 auto;
      width: 366px;
      height: 366px;
    }
    div {
      font-size: 18px;
      text-align: center;
      height: 40px;
      margin-top: 30px;
      line-height: 40px;
    }
  }
}

.login-position--left {
  position: absolute;
  top: 60%;
  left: 35%;
  z-index: 1001;
}

.login-position--right {
  position: absolute;
  top: 60%;
  left: 65%;
  z-index: 1001;
}

.footer-nav {
  font-size: 13px;
  width: 400px;
  text-align: center;
  color:white;
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translate(-50%, 0);
}

</style>



// WEBPACK FOOTER //
// src/components/login.vue